import React, { useState } from "react";

import Button from "@atoms/Button";
import Input from "@atoms/Input";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function HeaderMarket() {
  const { changeLanguage, lang } = useLanguage();
  const { openMarket } = useLayoutStore();

  const [country, setCountry] = useState(lang);

  return (
    <div className="pc:top-0 pc:h-auto pc:max-h-dvh pc:w-1/3 pc:bg-white pc:p-5 fixed top-13.5 right-0 z-60 flex h-dvh w-full flex-col gap-5 bg-white px-4 pb-4 lg:w-1/4 dark:bg-black dark:text-white">
      <div className="flex justify-between">
        <span className="col-span-8 uppercase">Shipping To</span>
        <Button
          as="text"
          className="pc:visible invisible"
          onClick={() => {
            localStorage.setItem("checkLocale", JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000));
            openMarket(false);
          }}
        >
          Close
        </Button>
      </div>
      <span className="text-title">Shipping Location • Currency</span>
      <div className="flex flex-col gap-2">
        <Input
          checked={country === "ko"}
          id="korea"
          label="South Korea • KRW ₩"
          name="country"
          onChange={() => {
            setCountry("ko");
          }}
          type="radio"
          value="ko"
        />
        <Input
          checked={country === "en"}
          id="world"
          label="Rest of the World • USD $"
          name="country"
          onChange={() => {
            setCountry("en");
          }}
          type="radio"
          value="en"
        />
        <Input
          checked={country === "jp"}
          id="japan"
          label="Japan • JPY ¥"
          name="country"
          onChange={() => {
            setCountry("jp");
          }}
          type="radio"
          value="jp"
        />
      </div>
      <Button
        as="square"
        onClick={() => {
          if (country === lang) {
            localStorage.setItem("checkLocale", JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000));
            openMarket(false);
          } else {
            changeLanguage(country);
          }
        }}
      >
        Submit
      </Button>
    </div>
  );
}
